import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=72781dbb&scoped=true&"
var script = {}
import style0 from "./Main.vue?vue&type=style&index=0&id=72781dbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72781dbb",
  null
  
)

export default component.exports